<div class="wrapper-quantities">
  @for (quantity of formattedOrderQuantities; track quantity; let last = $last) {
    <span>
      <span class="quantity">{{ quantity }}</span>
      @if (!last) {
        <span> | </span>
      }
    </span>
  }
  <ui-overlay [contentTemplate]="content" title="Bestellhistorie">
    <ui-icon class="order-quantities-info-icon" faName="info-circle" faStyle="light"></ui-icon>
  </ui-overlay>
</div>

<ng-template #content>
  <ui-table [collapsible]="false" [responsive]="false" [rows]="orderQuantities" class="order-quantities-table">
    <div name="date" uiTableColumn>
      <ng-template uiTableHeader>
        <span>Bestelldatum</span>
      </ng-template>
      <ng-template let-item="item" uiTableCell>
        {{ item.createdAt | luxonDate }}
      </ng-template>
    </div>
    <div name="quantity" uiTableColumn>
      <ng-template uiTableHeader>
        <span>Bestellmenge</span>
      </ng-template>
      <ng-template let-item="item" uiTableCell>
        {{ item.quantity }}
      </ng-template>
    </div>
  </ui-table>
</ng-template>
